import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'AD',
  version: 1,
  label: 'Accumulation/Distribution',
  pane: 'sub',
  category: 'volume',
  series: 'volume',
  order: 100,
  inputs: [],
  outputs: [line('ad', 'A/D', COLOR.blue)],
  talib: { functions: ['AD'], expr: 'AD(high, low, close, volume)' },
  listed: true,
  tailSafe: false,
  lookback: () => 0,
}
export default def
